module.exports = __webpack_public_path__ + "img/inco1.249a3a25.png";